import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c6a0528"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tabs-container",
  role: "tablist"
}
const _hoisted_2 = ["onClick", "id", "aria-selected", "aria-controls"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tabList, (tabName, index) => {
      return (_openBlock(), _createElementBlock("button", {
        key: index,
        class: _normalizeClass(["tab", { active: $props.currentTabIndex === index }]),
        type: "button",
        onClick: ($event: any) => ($setup.onChangeTab(index)),
        role: "tab",
        id: `tab-${index}`,
        "aria-selected": $props.currentTabIndex === index,
        "aria-controls": `tab-panel-${index}`
      }, _toDisplayString(tabName), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}